import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  rootURL = 'https://bogoplusapp.bit68.com';
  token_beh = new BehaviorSubject('');
  user_data = new BehaviorSubject({});
  constructor(public http: HttpClient) { }

  public isAuthenticated(): boolean {
    const token = this.getToken();
    if (token) {
      return true;
    }
    return false;
  }

  getToken() {
    this.token_beh.subscribe((val) => {
      return val;
    })
    return localStorage.getItem('bogo_token');
  }

  getProfileData() {
    return this.http.get(`${this.rootURL}/user-app/api-v2/MyProfileData/`)
  }

  signUp(formData) {
    return this.http.post(`${this.rootURL}/user-app/api-v2/UserCreateUpdate/`,
      {
        "name": formData.name,
        "email": formData.email,
        "gender": formData.gender,
        "mobile": formData.phone,
        "password": formData.matching_passwords.password,
        "birthdate": formData.birthdate,
        'from_website': true
      })
  }

  updateProfile(formData) {
    let body: any = {
      "name": formData.name,
      "email": formData.email,
      "gender": formData.gender,
      // "mobile": formData.phone,
      "birthdate": formData.birthdate
    }

    if (formData.matching_passwords && formData.matching_passwords.new_password) {
      body.password = formData.matching_passwords.new_password;
    }

    return this.http.patch(`${this.rootURL}/user-app/api-v2/UserCreateUpdate/`, body);
  }

  changePassword(formData) {
    let body: any = {};

    if (formData.matching_passwords && formData.matching_passwords.password) {
      body.password = formData.matching_passwords.password;
    }
    return this.http.patch(`${this.rootURL}/user-app/api-v2/UserCreateUpdate/`, body);

  }

  login(formData) {
    return this.http.post(`${this.rootURL}/user-app/api-v2/LogInView/`,
      {
        "username": formData.username,
        "password": formData.password,
        'from_website': true
      })
  }

  loginWithFacebook(accessToken, phone?) {
    return this.http.post(`${this.rootURL}/user-app/api-v2/LoginWithFacebookView/`,
      {
        "facebook_access_token": accessToken,
        "phone": phone,
        'from_website': true
      })
  }

  loginWithGoogle(accessToken, phone?) {
    return this.http.post(`${this.rootURL}/user-app/api-v2/LoginWithGmail/`, {
      "access_token": accessToken,
      "phone": phone,
      'from_website': true
    })
  }

  requestLogout() {
    return this.http.post(`${this.rootURL}/user-app/api-v2/signout/`,
      {
        "logout_requested": true
      })
  }

  cancelLogoutRequest() {
    return this.http.post(`${this.rootURL}/user-app/api-v2/signout/`,
      {
        "logout_requested": false
      })
  }

  logoutRequestStatus() {
    return this.http.get(`${this.rootURL}/user-app/api-v2/signout-status/`)
  }

  requestPasswordReset(formData) {
    return this.http.post(`${this.rootURL}/user-app/api-v2/ForgetPasswordView/`,
      {
        "email": formData.email,
        "mobile": formData.phone
      })
  }

  setNewPassword(formData) {
    let params = {
      "email": formData.email,
      "code": formData.code,
      "password": formData.matching_passwords.password
    }
    return this.http.get(`${this.rootURL}/user-app/api-v2/ForgetPasswordView/`, { params: params })
  }

  verifyCode(verification_code) {
    return this.http.post(`${this.rootURL}/user-app/api-v2/verifyPhone/`, { verification_code: verification_code })
  }

  resendCode() {
    return this.http.post(`${this.rootURL}/user-app/api-v2/ResendVerificationSMS/`, null)
  }

  getLeaderBoard(date, year) {
    let params = new HttpParams;
    params = params.set('date', date)

    if (year) {
      params = params.append('in_year', 'true');
    }

    return this.http.get(`${this.rootURL}/user-app/api-v2/LeaderBoardView/`, { params: params });
  }

  getNotificationsListing(page = 1) {
    return this.http.get(`${this.rootURL}/app/api-v2/NotificationList/?page=${page}`);
  }

  requestLoginOtp(formData) {
    return this.http.post(`${this.rootURL}/user-app/api-v2/auth/mobile/otp/`,
      {
        "phone": formData.phone,
        'from_website': true
      })
  }

  requestLogin(formData) {
    return this.http.post(`${this.rootURL}/user-app/api-v2/auth/mobile/login/`,
      {
        "phone": formData.phone,
        "otp": formData.otp,
        'from_website': true
      })
  }

  requestSignUpOtp(formData) {
    return this.http.post(`${this.rootURL}/user-app/api-v2/auth/mobile/signup/otp/request/`,
      {
        "phone": formData.phone,
        'from_website': true
      })
  }

  validateSignUpOtp(formData) {
    return this.http.post(`${this.rootURL}/user-app/api-v2/auth/mobile/signup/otp/validate/`,
      {
        "phone": formData.phone,
        "otp": formData.otp,
        'from_website': true
      })
  }

  requestSignUp(formData) {
    return this.http.post(`${this.rootURL}/user-app/api-v2/auth/mobile/signup/`,
      {
        "mobile": formData.phone,
        "name": formData.name,
        "email": formData.email,
        "gender": formData.gender,
        "birthdate": formData.birthdate,
        'from_website': true
      })
  }

  updatePhoneNumber(formData) {
    return this.http.post(`${this.rootURL}/user-app/api-v2/auth/mobile/update/`,
      {
        "phone": formData.new_phone,
        "otp": formData.otp,
        'from_website': true
      })
  }
}
